module.exports = __webpack_public_path__ + "static/img/meiti1.dabc15a8.png";